import type { GridComponentOption } from "echarts/components";

export class GridBuilder {
  private top: number;
  private right: number;
  private bottom: number;
  private left: number;
  private containLabel: boolean;

  constructor() {
    this.top = 50;
    this.right = 40;
    this.bottom = 70;
    this.left = 20;
    this.containLabel = true;
  }

  setTop(value: number): this {
    this.top = value;
    return this;
  }

  setRight(value: number): this {
    this.right = value;
    return this;
  }

  setBottom(value: number): this {
    this.bottom = value;
    return this;
  }

  setLeft(value: number): this {
    this.left = value;
    return this;
  }

  setContainLabel(value: boolean): this {
    this.containLabel = value;
    return this;
  }

  build(): GridComponentOption {
    return {
      top: this.top,
      right: this.right,
      bottom: this.bottom,
      left: this.left,
      containLabel: this.containLabel,
    };
  }
}
